<template>
  <v-container class="fill-height with-fancy-bg">
    <v-row align="center" class="fill-height" justify="center">
      <v-col>
        <v-card class="mx-auto" max-width="688px">
          <div class="right-language-switcher">
            <LanguageSwitcher />
          </div>
          <v-card-title class="text-center mt-10 auth-forms-top-title">
            <span class="text-primary">{{
              $t("views.resetPassword.ResetPassword")
            }}</span>
          </v-card-title>
          <v-card-subtitle v-if="errorMessage" class="auth-forms-sub-title text-center text-red">
            {{ $t("actions.error-message") }}
            {{ $t("actions.error-responses." + errorMessage) }}
          </v-card-subtitle>
          <v-card-subtitle v-else class="auth-forms-sub-title text-center">
            {{ $t("views.resetPassword.ResetPasswordDescription") }}
          </v-card-subtitle>

          <v-card-text>
            <v-form v-model="valid">
              <v-text-field v-model="email" autocomplete="email" class="my-2" clearable density="default"
                data-cy="forget-password-email" :label="$t('entities.user.fields.email')"
                :persistent-placeholder="false" :rules="emailRules" type="email" />

              <v-row>
                <v-col class="text-center">
                  <v-btn block class="text-none text-subtitle-1" color="primary" :disabled="!valid"
                    prepend-icon="mdi-check" rounded="xl" size="large" variant="flat" @click="submit"
                    data-cy="forget-password-submit">
                    {{ $t("actions.submit") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <router-link class="mr-4 auth-forms-sub-title" :to="{ name: 'login' }">
                    {{ $t("views.resetPassword.BackToLogin") }}
                  </router-link>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";

import LanguageSwitcher from "../../components/tools/LanguageSwitcher.vue";
import { useUserRules } from "../../validations/user.js";
import { useAuthStore } from "@/stores/authStore";

const authStore = useAuthStore();

const { t } = useTranslation();
const router = useRouter();

const errorMessage = ref(null);
const valid = ref(true);

const { emailRules } = useUserRules(t);

const email = ref("")

const submit = () => {
  authStore
    .requestResetPassword(email.value)
    .then(() => {
      router.push({
        name: "thank-you",
        params: { action: "reset-password" }
      });
    })
    .catch((error) => {
      errorMessage.value = error.response.data;
    });
};
</script>
